import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRolGetAll } from "../../../fnx/rol/rolGetAll";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { rolClearData } from "../../../store/rol/actions";
import { useFiltersParser } from "../../users/hooks/useFiltersParser";
// filtersApplied: any;
export var useRolesData = function (filtersApplied) {
    var dispatch = useDispatch();
    var _a = useState([]), rolesData = _a[0], setRolesData = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(19), limit = _d[0], setLimit = _d[1];
    var _e = useState(0), countData = _e[0], setCountData = _e[1];
    var _f = useState(""), searchQuery = _f[0], setSearchQuery = _f[1];
    var clientId = useState(findParamInLocalStorage("clientId"))[0];
    var filters = useFiltersParser(filtersApplied);
    useEffect(function () {
        setTrigger(true);
    }, []);
    // useEffect(() => {
    //   setPage(1);
    //   setTrigger(true);
    //   setSearchQuery("");
    // }, [filters]);
    useEffect(function () {
        if (searchQuery.length === 0 || searchQuery.length >= 3) {
            setTrigger(true);
        }
    }, [searchQuery]);
    var _g = useRolGetAll(trigger, clientId !== null && clientId !== void 0 ? clientId : "", page, limit, searchQuery), responseRol = _g.responseRol, errorRol = _g.errorRol, loadingRol = _g.loadingRol, pagingInfo = _g.pagingInfo;
    useEffect(function () {
        if (responseRol) {
            var mappedRoles = responseRol.map(function (rol) { return ({
                id: rol.id,
                codeLabel: "Nombre: ",
                code: rol.name,
                descriptionLabel: "Descripción: ",
                description: rol.description,
                fontSizeCode: 12,
                fontSizeDescription: 12,
                permissions: rol.permissions,
                clientId: rol.clientId,
            }); });
            setRolesData(mappedRoles);
            setTrigger(false);
            if (pagingInfo) {
                setCountData(pagingInfo.totalItems);
            }
            dispatch(rolClearData());
        }
    }, [responseRol]);
    return {
        rolesData: rolesData,
        loadingRol: loadingRol,
        errorRol: errorRol,
        countData: countData,
        setPage: setPage,
        page: page,
        setLimit: setLimit,
        limit: limit,
        callRoles: setTrigger,
        setSearchQuery: setSearchQuery,
    };
};
